export default {
    data() {
        return {
            form: {},
            endpoint: '',
            csrfToken: '',
            showErrorMessage: false,
            showConfirmMessage: false,
            errorMessage: Drupal.t('Please fill in all required fields.'),
            confirmMessage: Drupal.t('Thank you for filling in the survey!'),
            surveyEventBus: new Vue()
        }
    },

    methods: {
        getToken() {
            axios.get('/nl/session/token')
                .then(response => {
                    this.csrfToken = response.data
                })
                .catch(error => {
                    this.token = ''
                })
        },
    }
}